import { render, staticRenderFns } from "./StartView.vue?vue&type=template&id=69c4d54a&scoped=true&"
import script from "./StartView.vue?vue&type=script&lang=js&"
export * from "./StartView.vue?vue&type=script&lang=js&"
import style0 from "./StartView.vue?vue&type=style&index=0&id=69c4d54a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c4d54a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
